module.exports = __webpack_public_path__ + "0099f0a41025b5597fa7b6488842e13e.png";